import React from "react";
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { Grid } from '@material-ui/core';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import LogoIES from '././img/LogoIES.png';
import Tooltip from '@material-ui/core/Tooltip';
import GraficaIES from "./graficaIES";
import './graficas.css'

const HtmlTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: '#f5f5f9',
        color: 'rgba(0, 0, 0, 0.87)',
        maxWidth: 220,
        fontSize: theme.typography.pxToRem(15),
        border: '1px solid #dadde9',
    },
}))(Tooltip);

const useStyles = makeStyles({
    depositContext: {
        flex: 1,
    },
    total: {
        fontFamily: "'Segoe UI Variable Static Display 700', sans-serif",
        fontWeight: 'bold',
        marginLeft: '54%',
        marginTop: '-9%'
    },
    texttotal: {
        flex: 1,
        marginLeft: '156%',
        marginTop: '-36%',
        fontFamily: "'Segoe UI Variable Static Display 700', sans-serif",
        fontSize: '22px'
    }
});

function calcularPorcentaje(valor, total) {
    let result = (valor / total) * 100
    return (result.toFixed(0))
}

export default function ChartIes({ data, max, fechaIni, fechaFin }) {
    const classes = useStyles();

    const saludable = data?.saludable || 0;
    const MaMEjora = data?.margen_de_mejora || 0;
    const ActReq = data?.accion_requerida || 0;
    const gv = data?.gv || 0;
    const sinR = data?.no_registra || 0;
    const maximo = saludable + MaMEjora + ActReq + gv + sinR;

    const porcentajeSaludable = calcularPorcentaje(saludable, maximo);
    const porcentajeMaMEjora = calcularPorcentaje(MaMEjora, maximo);
    const porcentajeActReq = calcularPorcentaje(ActReq, maximo);
    const porcentajeGv = calcularPorcentaje(gv, maximo);
    const porcentajeSinR = calcularPorcentaje(sinR, maximo);

    const categories = [
        'Saludable', 'Margen de mejora', 'Accion requerida', 'Grupo vulnerable', 'Sin registro'
    ];

    const datas = [
        saludable, MaMEjora, ActReq, gv, sinR
    ];

    const customColors = [
        '#1983c4', '#48457c', '#79385f', '#a92a41', 'gray'
    ];

    const porcentajes = [
        porcentajeSaludable, porcentajeMaMEjora, porcentajeActReq, porcentajeGv, porcentajeSinR
    ];

    return (
        <Grid container spacing={2} alignItems="center" justifyContent="center">
            <Grid item xs={12} sm container>
                {/* Columna del logo */}
                <Grid item xs={12} sm={3} container alignItems="center" justifyContent="center" style={{ width: "385px", marginTop: '-3%' }}>
                    <img src={LogoIES} width='80%' alt="Logo IES" />
                </Grid>

                {/* Columna de la gráfica (más ancha) */}
                <Grid item xs={12} sm={6} container alignItems="center" justifyContent="center" style={{ height: '306px', marginTop: '-2%' }}>
                    <Typography align="center" style={{ fontWeight: 'bold', fontSize: "30px" }}color="primary" >
                        Índice de Empleado Saludable
                    </Typography>
                    <GraficaIES categories={categories} data={datas} customColors={customColors} porcentajes={porcentajes} />
                </Grid>


                {/* Columna de los colores */}
                <Grid item style={{ width: "300px", marginTop: '3%', marginLeft: '-5%' }}>
                    <Grid container spacing={1} alignItems="left" justifyContent="center">
                        <Grid item xs={12} sm={4} lg={2}>
                            <FiberManualRecordIcon style={{ color: "#1983c4", alignItems: "left" }} />
                        </Grid>
                        <Grid style={{ fontSize: '17px', whiteSpace: 'nowrap', paddingLeft: '10px' }} item xs={12} sm={4} lg={8}>
                            Saludable-{saludable}
                        </Grid>
                        <Grid item xs={12} sm={4} lg={2}>
                            <div align="right">
                                <HtmlTooltip
                                    title={
                                        <React.Fragment>
                                            <Typography>Descripción</Typography>
                                            <b><br />{"SALUDABLE: "}</b>{' '}
                                            {"Usuarios que según el índice se encuentran en estado de salud idóneo, tiene entre 0 - 2 puntos"}
                                        </React.Fragment>
                                    }
                                    placement="right-start"
                                >
                                    <HelpOutlineIcon style={{ height: '21px', marginLeft: '10%' }}color="primary" />
                                </HtmlTooltip>
                            </div>
                        </Grid>
                    </Grid>


                    <Grid container spacing={1} alignItems="center" justifyContent="center">
                        <Grid item xs={12} sm={4} lg={2}>
                            <FiberManualRecordIcon style={{ color: "#48457c" }} />
                        </Grid>
                        <Grid style={{ fontSize: '17px', whiteSpace: 'nowrap', marginTop: '-5%', paddingLeft: '10px' }} item xs={12} sm={4} lg={8}>
                            Margen de Mejora-{MaMEjora}
                        </Grid>
                        <Grid item xs={12} sm={4} lg={2}>
                            <div align="right">
                                <HtmlTooltip
                                    title={
                                        <React.Fragment>
                                            <Typography>Descripción</Typography>
                                            <b><br />{"MÁRGEN DE MEJORA:"}</b>{' '}
                                            {"Usuarios que según el índice se encuentran en posibilidad de mejorar su estado de salud,tiene entre 3 - 5 puntos"}
                                        </React.Fragment>
                                    }
                                    placement="right-start"
                                >
                                    <HelpOutlineIcon style={{ height: '21px', marginLeft: '10%' }} color="primary" />
                                </HtmlTooltip>
                            </div>
                        </Grid>
                    </Grid>


                    <Grid container spacing={1} alignItems="center" justifyContent="center">
                        <Grid item xs={12} sm={4} lg={2}>
                            <FiberManualRecordIcon style={{ color: "#79385f" }} />
                        </Grid>
                        <Grid style={{ fontSize: '17px', whiteSpace: 'nowrap', marginTop: '-5%', paddingLeft: '10px' }} item xs={12} sm={4} lg={8}>
                            Acción Requerida-{ActReq}
                        </Grid>
                        <Grid item xs={12} sm={4} lg={2}>
                            <div align="right">
                                <HtmlTooltip
                                    title={
                                        <React.Fragment>
                                            <Typography>Descripción</Typography>
                                            <b><br />{"ACCIÓN REQUERIDA:"}</b>{' '}
                                            {"Usuarios que según el índice necesitan realizar acciones para mejorar su estado de salud,tiene entre 6 - 98 puntos"}
                                        </React.Fragment>
                                    }
                                    placement="right-start"
                                >
                                    <HelpOutlineIcon style={{ height: '21px', marginLeft: '10%' }}color="primary" />
                                </HtmlTooltip>
                            </div>
                        </Grid>
                    </Grid>


                    <Grid container spacing={1} alignItems="center" justifyContent="center">
                        <Grid item xs={12} sm={4} lg={2}>
                            <FiberManualRecordIcon style={{ color: "#a92a41" }} />
                        </Grid>
                        <Grid style={{ fontSize: '17px', whiteSpace: 'nowrap', marginTop: '-5%', paddingLeft: '10px' }} item xs={12} sm={4} lg={8}>
                            Grupo vulnerable-{gv}
                        </Grid>
                        <Grid item xs={12} sm={4} lg={2}>
                            <div align="right">
                                <HtmlTooltip
                                    title={
                                        <React.Fragment>
                                            <Typography>Descripción</Typography>
                                            <b><br />{"GRUPO VULNERABLE:"}</b>{' '}
                                            {"Nivel de Acción con Especialista, tiene más de 100 puntos."}
                                        </React.Fragment>
                                    }
                                    placement="right-start"
                                >
                                    <HelpOutlineIcon style={{ height: '21px', marginLeft: '10%' }} color="primary" />
                                </HtmlTooltip>
                            </div>
                        </Grid>
                    </Grid>


                    <Grid container spacing={1} alignItems="center" justifyContent="center">
                        <Grid item xs={12} sm={4} lg={2}>
                            <FiberManualRecordIcon style={{ color: "#c1c1c1" }} />
                        </Grid>
                        <Grid style={{ fontSize: '17px', whiteSpace: 'nowrap', marginTop: '-5%', paddingLeft: '10px' }} item xs={12} sm={4} lg={8}>
                            Sin Registro-{sinR}
                        </Grid>
                        <Grid item xs={12} sm={4} lg={2}>
                            <div align="right">
                                <HtmlTooltip
                                    title={
                                        <React.Fragment>
                                            <Typography>Descripción</Typography>
                                            <b><br />{"SIN REGISTRO:"}</b>{' '}
                                            {"Usuarios que por falta de información en algún parámetro no es posible calcular su IES."}
                                        </React.Fragment>
                                    }
                                    placement="right-start"
                                >
                                    <HelpOutlineIcon style={{height: '21px', marginLeft: '10%' }} color="primary" />
                                </HtmlTooltip>
                            </div>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <Typography component="p" align="center" variant="h3" className={classes.total}>
                            {maximo === null && undefined ? "-" : maximo}
                        </Typography>
                        <Typography color="textSecondary" align="center" variant="h5" className={classes.texttotal}>
                            Total
                        </Typography>
                    </Grid>
                </Grid>


            </Grid>
        </Grid>
    );
}
